import { ColumnParams, JournalFactory, JournalState, QueryRequestSourceData } from '../common';
import { isExists, isHasLength, isNotExists } from './is.utils';
import { DiffWithState } from './rxjs.utils';

function getSortByColumns(cols: ColumnParams[]): ColumnParams[] {
  return cols.filter((obj) => obj.sortOrder >= 0).sort((f, s) => (f.sortOrder > s.sortOrder ? 1 : -1));
}

function isColumnsSortSame(oldCols: ColumnParams[], newCols: ColumnParams[]): boolean {
  if (!isExists(oldCols)) {
    return !isHasLength(newCols);
  }

  if (oldCols.length !== newCols.length) {
    return false;
  }
  return !oldCols.some((oldCol, i) => !isSameSort(oldCol, newCols[i]));
}

function isSameSort(f: ColumnParams, s: ColumnParams): boolean {
  return s.uniqueId === f.uniqueId && s.sortDirection === f.sortDirection;
}

export function getQueryRequestSourceData(
  prevData: QueryRequestSourceData | null,
  { diff, newState }: DiffWithState<JournalState>,
  factory: JournalFactory,
): QueryRequestSourceData {
  const fields: Partial<QueryRequestSourceData> = {};

  const firstTime = isNotExists(prevData);

  if (firstTime || isExists(diff.searchText)){// || exists(diff.filterValues) || exists(diff.systemFilters)) {
    // const filtersForRequest = getJournalFilter(newState, factory);
    // if (firstTime || !isFilterValuesSame(prevData.filters, filtersForRequest)) {
    //   fields.filters = filtersForRequest;
    // }
  }

  if (firstTime || isExists(diff.journalCode)) {
    fields.journalCode = newState.journalCode;
  }

  if (firstTime || isExists(diff.displayingColumns)) {
    const sort = getSortByColumns(newState.displayingColumns);
    const prevSort = prevData ? prevData.sort : [];
    if (firstTime || !isColumnsSortSame(prevSort, sort)) {
      fields.sort = sort;
    }
  }

  if (firstTime) {
    return fields as QueryRequestSourceData;
  } else if (Object.keys(fields).length > 0) {
    return { ...(prevData as unknown as Object), ...(fields as unknown as Object) } as QueryRequestSourceData;
  }

  return { ...(prevData as unknown as Object) } as QueryRequestSourceData;
}
